export enum EQueryKeys {
  AwsQueryKeys = 'AwsQueryKeys',
}
